var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2503 4H27.0003V6H30.0003V28H2.00026V6H5.00026V4H1.75026C1.51649 4.00391 1.28579 4.05383 1.07132 4.14691C0.856857 4.23999 0.662828 4.37441 0.500319 4.54249C0.33781 4.71057 0.210004 4.90902 0.124203 5.1265C0.0384012 5.34398 -0.00371596 5.57624 0.000257051 5.81V28.19C-0.00371596 28.4238 0.0384012 28.656 0.124203 28.8735C0.210004 29.091 0.33781 29.2894 0.500319 29.4575C0.662828 29.6256 0.856857 29.76 1.07132 29.8531C1.28579 29.9462 1.51649 29.9961 1.75026 30H30.2503C30.484 29.9961 30.7147 29.9462 30.9292 29.8531C31.1437 29.76 31.3377 29.6256 31.5002 29.4575C31.6627 29.2894 31.7905 29.091 31.8763 28.8735C31.9621 28.656 32.0042 28.4238 32.0003 28.19V5.81C32.0042 5.57624 31.9621 5.34398 31.8763 5.1265C31.7905 4.90902 31.6627 4.71057 31.5002 4.54249C31.3377 4.37441 31.1437 4.23999 30.9292 4.14691C30.7147 4.05383 30.484 4.00391 30.2503 4Z",
    fill: "#FF8354"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6V12Z",
    fill: "#FF8354"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14V14H12V12Z",
    fill: "#FF8354"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H20V14H18V12Z",
    fill: "#FF8354"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H26V14H24V12Z",
    fill: "#FF8354"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H8V19H6V17Z",
    fill: "#FF8354"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H14V19H12V17Z",
    fill: "#FF8354"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H20V19H18V17Z",
    fill: "#FF8354"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H26V19H24V17Z",
    fill: "#FF8354"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H8V24H6V22Z",
    fill: "#FF8354"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H14V24H12V22Z",
    fill: "#FF8354"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18V22Z",
    fill: "#FF8354"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H26V24H24V22Z",
    fill: "#FF8354"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8Z",
    fill: "#FF8354"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8C24.2652 8 24.5196 7.89464 24.7071 7.70711C24.8946 7.51957 25 7.26522 25 7V1C25 0.734784 24.8946 0.48043 24.7071 0.292893C24.5196 0.105357 24.2652 0 24 0C23.7348 0 23.4804 0.105357 23.2929 0.292893C23.1054 0.48043 23 0.734784 23 1V7C23 7.26522 23.1054 7.51957 23.2929 7.70711C23.4804 7.89464 23.7348 8 24 8Z",
    fill: "#FF8354"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4H21V6H11V4Z",
    fill: "#FF8354"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.77c9a15616106e9d7f8d42c56b0b1f28.svg";
export { ForwardRef as ReactComponent };